<template>
  <div id="settings">
    <v-app>

      <!-- PROFILE -->
      <div class="settings-card padded">
        <vo-settings-profile></vo-settings-profile>
      </div>

      <!-- PASSWORD -->
      <div class="settings-card padded">
        <vo-settings-password></vo-settings-password>      
      </div>

      <!-- EMAIL -->
      <div class="settings-card padded">
        <vo-settings-email></vo-settings-email>
      </div>

      <!-- NOTIFICATIONS -->
      <div class="settings-card padded">
        <vo-settings-notifications></vo-settings-notifications>
      </div>

      <!-- NOTIFICATIONS SCHEDULE -->
      <div class="settings-card">
        <vo-settings-notifications-schedule></vo-settings-notifications-schedule>
      </div>

    </v-app>
  </div>
</template>

<script>

  export default {
    data () {
      return {
        
      }
    }
  }

</script>

<style lang="scss">

  @import '../css/global.scss';

  #settings {

    @include scrollable();

    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    padding: 16px;
    box-sizing: border-box;
    background: #FAFAFA;

    .settings-card {
      max-width: 500px;
      width: 100%;
      margin: 0 auto 16px;
      box-sizing: border-box;
      box-shadow: $cardShadow;
      background-color: #FFF;
    
      @include fontPrimary400();

      .name {
        @include fontPrimary500();
        @include title();
        text-align: center;
        width: calc(100% - 32px);
        margin: 0 auto;
        padding: 16px;
        font-size: 16px;
        border-bottom: $borderBlack12;
        box-sizing: border-box;
      }

      .context {
        font-size: 14px;
        color: $black87;
        line-height: 16px;
        text-align: center;
        padding: 24px 24px 16px;
      }

      .settings-content {
        padding: 24px;
      }

      .buttons {
        color: $primary;
        margin: 16px;
        float: right;
      }

    } // .card
  
  }

</style>



// WEBPACK FOOTER //
// src/components/Settings.vue